<template>
  <div  v-loading="loading">
    <el-dialog ref='dialog' :title="title">

      <!--日志记录-->
      <div class="content" v-if='model == "logList"'>
        <el-table 
          :data='tableData'
          border
          style="width: 100%">
          <el-table-column v-for="col in columns" :label="col.title" >
            <template scope="scope">  
              <el-button type="text" v-if="col.name == 'id'" @click='openDetail(scope.row.id)'>详情</el-button>
              <a class='download' :href="scope.row[col.name]" v-else-if="col.name == 'import_url'">下载</a>
              <span v-else-if="col.name == 'create_time'"> {{ scope.row[col.name] | toDate }}</span>
              <span v-else>{{scope.row[col.name]}}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--详情-->
      <div class="content" v-if='model == "logDetail"'>
        <el-table 
          :data='curDetail.list'
          border
          style="width: 100%">
          <el-table-column v-for="col in curDetail.column" :label="col.title" >
            <template scope="scope"> 
              <span >{{scope.row[col.name]}}</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="m-t-20 m-b-20 ovf-hd">
          <div class="fr">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              layout="total, sizes, prev, pager, next"
              :page-sizes="pageSizes"
              :page-size="currentSize"
              :current-page="currentPage"
              :total="total">
            </el-pagination>
          </div>
          <div style="clear:both"></div>
        </div>
      </div>
      
      <div class="footer">
        <el-button @click="changeModel('logList')" v-if='model == "logDetail"'>返回日志记录</el-button>
        <el-button type="primary" v-if='model == "logList"' @click="closeDialog()">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<style>
  .download{
    color: #4db3ff
  }
  .hr {
    clear:both;
    margin-bottom: 10px;
    margin-top:10px;
    height: 1px;
    background: #000000;
  }
  .el-dialog--small {
    width: 60%;
  }
  .el-table .tableColumnClass {
    height: 50px;
  }
  .footer {
    text-align: right;
    height: 50px;
    line-height: 50px;
    margin-top: 30px;
  }
  .selectMapName .el-form-item__content {
    float: left;
  }
  .content {
    max-height: 450px;
    overflow-y: auto;
  }
</style>
  
<script>
import http from '../../../assets/js/http'
export default {
  props: {
    tempImportlogData: {
      type: Object,
      default() {
        return {}
      }
    },
    importId: {
      type: Number,
      default() {
        return 0
      }
    },
    contentId: {
      type: Number,
      default() {
        return 0
      }
    }
  },
  data() {
    return {
      loading: false,
      title: '导入记录',
      host: '',
      tableData: [],
      columns: [],
      model: 'logList',
      curDetail: [],
      currentPage: 1, // 当前页码
      currentSize: 0,  // 当前一页数据数量
      total: 0, // 总条数
      pageSizes: [15]
    }
  },
  created() {
    this.host = HOST
  },
  methods: {
    open() {
      this.$refs.dialog.open()
      this.model = 'logList'
    },
    closeDialog() {
      this.$refs.dialog.close()
    },
    async openDetail(logId) {
      this.loading = true
      this.curDetail = await this.getLogDetail(logId)
      this.total = this.curDetail.count
      this.loading = false
      this.model = 'logDetail'
    },
    async getLogDetail(logId) {  // 根据log_id获取日志详情
      let arr = []
      let postData = {
        params: {
          limit: 15,
          page: this.currentPage
        }
      }
      let res = await this.apiGet(`cms/contents/${this.contentId}/excellog/${this.importId}/detail/${logId}`, postData)
      return this.promiseHandler(arr, res)
    },
    changeModel(model) {
      this.model = model
    },
    handleParams(arr) {
      setTimeout(() => {
        this.$emit('handleParams', arr)
      }, 0)
      this.closeDialog()
    },
    handleSizeChange(size) { // 一页有多少条
      this.limit = size
    },
    handleCurrentChange(val) { // 换页
      this.currentPage = val
    }
  },
  watch: {
    model() {
      if (this.model == 'logDetail') {
        this.title = '查看详情'
      } else {
        this.title = '导入记录'
      }
    },
    tempImportlogData() {
      this.tableData = _.cloneDeep(this.tempImportlogData.list)
      this.columns = _.cloneDeep(this.tempImportlogData.column)
      _(this.tableData).forEach((list) => {
        list.import_url = this.host + list.import_url
      })
    }
  },
  mixins: [http]
}
</script>



// WEBPACK FOOTER //
// importlogDialog.vue?1d64e57e